import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";
import { languages, checkLineCount, combineErrors, signatureInfo, size, getContentField } from "./shared";


const christmasText = 'Zum Weihnachtsfest wünschen wir Euch besinnliche Stunden. Zum Jahreswechsel Heiterkeit und Frohsinn. Für das Neue Jahr Gesundheit, Glück und Erfolg!'


export const christmasTemplateData: CustomerTemplate = {
    key: 'christmas',
        name: {
            de: 'Weihnachtskarte',
            en: 'Christmas card'
        },
        ...size,
        languages,
        signatureInfo,
        templateData: [
            {
                key: 'headlineTop',
                name: {
                    en: 'Headline Top',
                    de: 'Überschrift obere Zeile'
                },
                languageData: {
                    'de': 'Frohe',
                    'en': 'Merry'
                },
                maxLength: 12,
                hide: false,
                isValid: combineErrors([checkLineCount(1)])
            },
            {
                key: 'headlineBottom',
                name: {
                    en: 'Headline Bottom',
                    de: 'Überschrift untere Zeile'
                },
                languageData: {
                    'de': 'Weihnachten',
                    'en': 'Christmas'
                },
                maxLength: 12,
                hide: false,
                isValid: combineErrors([checkLineCount(1)])
            },
            {
                key: 'subHeadline',
                name: {
                    en: 'Sub headline',
                    de: 'Untertitel'
                },
                languageData: {
                    'de': 'Herzliche Weihnachtsgrüße',
                    'en': 'Christmas greetings'
                },
                maxLength: 35,
                hide: false,
                isValid: combineErrors([checkLineCount(1)])
            },
            {
                key: 'subHeadline2',
                name: {
                    en: 'Sub headline',
                    de: 'Untertitel'
                },
                languageData: {
                    'de': 'Und ein glückliches neues Jahr!',
                    'en': 'And a happy new year!'
                },
                maxLength: 35,
                hide: false,
                isValid: combineErrors([checkLineCount(1)])
            },
            getContentField(christmasText)
        ],
        font: {
            headlineTop: {
                family: 'Parisienne-Regular',
                color: '#fff', 
                size: 55,
                TopPadding: 445,
                lineHeight: 55
            },
            headlineBottom: {
                family: 'Parisienne-Regular',
                color: '#fff', 
                size: 55,
                TopPadding: 445,
                lineHeight: 48
            },
            subHeadline: {
                family: 'Roboto-Light',
                color: '#fff', 
                size: 20,
                TopPadding: 60,
                yScale2: 20,
                lineHeight: 55
            },
            doubleHeadline: true,
            subHeadline2: {
                family: 'Roboto-Light',
                color: '#fff', 
                size: 20,
                TopPadding: 530,
                lineHeight: 55
            },
            content: {
                family: 'Roboto-Light',
                color: '#fff', 
                size: 16,
                TopPadding: 560,
                lineHeight: 20
            }
        },
        signature: {
            topPadding: 570,
            contentDep: true,
            singleSignature: false,
            fontSize: 30,
            fontSizeSub: 10,
            color: '#fff'
        }
}



    